import ReactTabHotkeyReplacer from './ReactTabHotkeyReplacer';
export default ReactTabHotkeyReplacer;
